__turbopack_context__.v({
  "add": "index-module-scss-module__9vBK3a__add",
  "applied": "index-module-scss-module__9vBK3a__applied",
  "blinker": "index-module-scss-module__9vBK3a__blinker",
  "codes": "index-module-scss-module__9vBK3a__codes",
  "discountError": "index-module-scss-module__9vBK3a__discountError",
  "form": "index-module-scss-module__9vBK3a__form",
  "input": "index-module-scss-module__9vBK3a__input",
  "note": "index-module-scss-module__9vBK3a__note",
  "remove": "index-module-scss-module__9vBK3a__remove",
  "voucher": "index-module-scss-module__9vBK3a__voucher",
  "wrapper": "index-module-scss-module__9vBK3a__wrapper",
});
